import moment from 'moment';
import React, { useMemo } from 'react';
import { Linking, Text, TouchableOpacity, View } from 'react-native';
import { IconButton as RNIconButton } from 'react-native-paper';
import { createStyle } from '../style';
import { CHAIN_IDS, JPYCTransferProps, NETWORKS } from '../type';

type Props = {
  errorMessage?: string;
  onBack: () => void;
  jpycElementProps: JPYCTransferProps;
};
export const ErrorForm: React.FC<Props> = (props) => {
  const { errorMessage, jpycElementProps, onBack } = props;
  const styles = createStyle(jpycElementProps);

  return (
    <View style={styles.container}>
      <View style={styles.iconWrapper}>
        <View style={[styles.iconCircle, { backgroundColor: '#FF0000' }]}>
          <RNIconButton icon="alert" onPress={() => {}} color="#ffffff" />
        </View>
      </View>

      <View style={styles.headerBlock}>
        <Text style={[styles.title, { color: '#FF0000' }]}>支払い失敗</Text>
      </View>

      <View
        style={{
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Text style={[styles.subtitle, { textAlign: 'center' }]}>
          支払い処理ができませんでした。
        </Text>
        <Text style={[styles.subtitle, { textAlign: 'center' }]}>
          再度処理を行う場合は、もう一度やり直してください。
        </Text>
      </View>

      <TouchableOpacity
        style={[styles.button, { backgroundColor: '#f2f5f7', marginTop: 20 }]}
        onPress={onBack}
        activeOpacity={0.85}
      >
        <Text style={{ color: '#000', fontSize: 12 }}>
          利用中のサービスに戻る
        </Text>
      </TouchableOpacity>
    </View>
  );
};
